// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1L987","savePackageButton":"ClientWallet_savePackageButton__3JTFa"};